import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { SystemUpdateAlt } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import Interweave from 'interweave';
import { useStyles } from './styles';

class LessonType {
  static HTML = 3;
  static EXAM = 6;
  static IFRAME = 8;
  static IFRAMEINTERACT = 9;
  static HYBRID = 10;
}

const vimeoPlayerUrl = (url_vimeo) =>
  `${window._env_.REACT_APP_VIMEO_DOMAIN}${url_vimeo.replace(
    '/videos',
    '/video'
  )}?portrait=0&byline=0&title=0`;

function FilePreview({ file }) {
  const { t } = useTranslation(['button']);
  const classes = useStyles();
  const type = file?.file_type || '';

  if (type === 'application/pdf')
    return <iframe title={file.name} src={file.url} className={classes.pdf} />;
  if (type.startsWith('image/'))
    return <img alt={file.name} src={file.url} className={classes.image} />;
  if (type.startsWith('audio/'))
    return <audio controls src={file.url} className={classes.audio} />;
  if (type.startsWith('video/'))
    return <video controls src={file.url} className={classes.image} />;

  return (
    <Button
      variant="outlined"
      color="primary"
      href={file.url}
      target="_blank"
      rel="noopener noreferrer"
      download={file.name}
    >
      <SystemUpdateAlt style={{ marginRight: 8 }} />
      {t('button:commons.btn_download')} - {file.name}
    </Button>
  );
}

function ContentBody({ content }) {
  const { t } = useTranslation(['label']);
  const classes = useStyles();

  if (content.url_vimeo) {
    return (
      <div className={classes.videoFrame}>
        <div className={classes.videoWrapper}>
          <iframe
            title={content.name}
            src={vimeoPlayerUrl(content.url_vimeo)}
            frameBorder="0"
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
          />
        </div>
      </div>
    );
  }

  if (content.file?.url) return <FilePreview file={content.file} />;

  if (content.type === LessonType.HTML && content.content)
    return <Interweave content={content.content} />;

  if (
    [LessonType.IFRAME, LessonType.IFRAMEINTERACT].includes(content.type) &&
    content.content
  ) {
    return (
      <div className={classes.videoFrame}>
        <div
          className={classes.videoWrapper}
          dangerouslySetInnerHTML={{ __html: content.content }}
        />
      </div>
    );
  }

  if (content.type === LessonType.EXAM)
    return (
      <Typography color="textSecondary">
        {t('label:Lesson.label_preview_exam')}
      </Typography>
    );

  if (content.type === LessonType.HYBRID)
    return (
      <Typography color="textSecondary">
        {t('label:Lesson.label_presencial')}
      </Typography>
    );

  return (
    <Typography color="textSecondary">
      {t('label:Lesson.label_preview_unsupported')}
    </Typography>
  );
}

export default ({ contents }) => {
  const { t } = useTranslation(['label']);
  const classes = useStyles();

  if (!contents?.length)
    return (
      <Typography color="textSecondary" className={classes.empty}>
        {t('label:Lesson.label_preview_empty')}
      </Typography>
    );

  return contents.map((content) => (
    <div key={content.id} className={classes.content}>
      {content.description && content.type !== LessonType.HTML && (
        <Typography color="textSecondary" className={classes.description}>
          {content.description}
        </Typography>
      )}
      <ContentBody content={content} />
    </div>
  ));
};
